import { getUserCurrentDate } from "./getUserCurrentDate";

const createShareURL = (blocks, head, tail, strikes=[], blocksOnly=false) => {
    let result = [];
    if(blocks && typeof blocks[0] === 'number'){
        return oldCreateShareURL(blocks, head, tail);
    }
    if(blocks && typeof blocks[0] === 'string'){
        if(blocksOnly){
            return blocks
        }
        else{
            let val = `dt=${getUserCurrentDate()}&blocks=${blocks.join(",")}`;
            return `${window.location.origin}/share?${val}`;
        }
    }
    blocks.forEach((b) => {
        let typeLetter = b?.type[0]?.toUpperCase();
        let id = b.id;
        let ribbon = b.select_count === 0 ? "-r" : "";
        result.push(typeLetter + id + ribbon);
    });
    strikes?.forEach(({ idx, direction, strikeInfo }) => {
        let insertIndex = direction === 'fwd' ? idx : result.length - idx;
        if(strikeInfo.goBack){
            return 
        }
        if(strikeInfo.hintUsed){
            let typeLetter = strikeInfo.type[0].toUpperCase();
            const idStr = `${typeLetter}${strikeInfo.id}`;
            const strikeStr = `${idStr}-h`;
            const existingIndex = result.findIndex(item => item === idStr || item.startsWith(idStr + '-'));
            if(existingIndex !== -1){
                result[existingIndex] = strikeStr;
            } else {
            result.splice(insertIndex, 0, strikeStr);
            }
        }
        else{
            let typeLetter = strikeInfo.type[0].toUpperCase();
            const strikeStr = `${typeLetter}${strikeInfo.id}-s`;
            const idStr = `${typeLetter}${strikeInfo.id}`;
            const existingIndex = result.findIndex(item => item === idStr || item.startsWith(idStr + '-'));
            if(existingIndex !== -1){
            result[existingIndex] = strikeStr;
            } else {
            result.splice(insertIndex, 0, strikeStr);
            }
        }
    });
    let tailTypeLetter = tail.type[0].toUpperCase();
    result.push(`${tailTypeLetter}${tail.id}`);
    let headTypeLetter = head.type[0].toUpperCase();
    result.unshift(`${headTypeLetter}${head.id}`);
    let val = `dt=${getUserCurrentDate()}&blocks=${result.join(",")}`;
    if(blocksOnly){
        return result
    }
    else{
        return `${window.location.origin}/share?${val}`;
    }
};

const oldCreateShareURL = (b, head, tail) => {
    let ids = []
    if(typeof b[0] === 'number'){
        ids = b
    }
    else{
        ids = b.map(block => block.id)
    }
    ids = ids.join(",")
    let query = `dt=${getUserCurrentDate()}&ht=${head.type}&blocks=${head.id},${ids},${tail.id}`;
    return `${window.location.origin}/share?${query}`;
  };

export default createShareURL